import { createFeatureSelector } from '@ngrx/store';
import { DashboardDataState } from './dashboard.reducer';

export const dashboardDataState = createFeatureSelector<DashboardDataState>('dashboard');
